import {useEffect, useState} from 'react'
import theme from '../../themes/pTheme/pTheme'
import PropTypes from 'prop-types'
const GraphTooltip = ({chartRef, visibility, handelTooltip, setTooltipVisible}) => {
  const [tooltipPosition, setTooltipPosition] = useState({})
  const tooltip = chartRef.current.tooltip
  const style = {
    display: 'flex',
    width: '300px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    background: theme.palette.hpWhite,
    borderRadius: '9px',
    boxShadow: '0 0 40px rgba(0,0,0,0.2)',
    color: theme.palette.hpAccentBlack,
    pointerEvents: 'none',
    position: 'absolute',
    transform: 'translate(-50%, 0)',
    backgroundColor: theme.palette.hpWhite,
    font: tooltip.options.bodyFont.string,
    padding: tooltip.options.padding + 'px',
    zIndex: 1222
  }
  if (tooltipPosition !== chartRef.current.position) {
    setTooltipPosition(chartRef.current.position)
  }
  useEffect(() => {
    setTooltipVisible(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tooltipPosition])

  const result = handelTooltip(tooltip?.dataPoints)
  const fontWidth = result?.length >= 2 ? theme.typography.fontWeightSemibold : theme.typography.fontWeightBold
  return (
    visibility && (
      <div
        style={{
          ...style,
          ...chartRef.current.position
        }}
      >
        {tooltip.body && (
          <table style={{width: '100%'}}>
            <tbody>
              {result.map((body, j) => {
                return body.map((row, i) => {
                  const key = Object.keys(row)

                  return (
                    <tr
                      key={key[0]}
                      style={{
                        backgroundColor: 'inherit',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        borderWidth: 0,
                        height: '30px'
                      }}
                    >
                      <td
                        style={{
                          borderWidth: 0,
                          fontWeight: i === 0 ? theme.typography.fontWeightBold : 'initial',
                          padding: '5px',
                          fontSize: theme.typography.h6.fontSize,
                          fontStyle: 'normal',
                          fontFamily: 'Open Sans',
                          lineHeight: 'normal'
                        }}
                      >
                        {key[0]}
                      </td>
                      <td
                        style={{
                          borderWidth: 0,
                          float: 'right',
                          width: 'max-content',
                          textAlign: 'right',
                          fontWeight: fontWidth
                        }}
                      >
                        {i === 0 ? (
                          <div
                            style={{
                              backgroundColor: tooltip?.dataPoints[j]?.dataset?.backgroundColor,
                              width: '15px',
                              height: '15px',
                              borderRadius: '50%',
                              float: 'right'
                            }}
                          />
                        ) : (
                          row[key[0]]
                        )}
                      </td>
                    </tr>
                  )
                })
              })}
            </tbody>
          </table>
        )}
      </div>
    )
  )
}

GraphTooltip.propTypes = {
  chartRef: PropTypes.object,
  visibility: PropTypes.bool,
  handelTooltip: PropTypes.func,
  setTooltipVisible: PropTypes.func
}

export default GraphTooltip
